import { AnchorHTMLAttributes } from 'react'
import cx from 'classnames'

import {
  ButtonProps,
  getButtonStyles,
  ButtonIcon,
  iconSizeClasses,
} from './button'

const ButtonLink = ({
  href,
  target,
  rel,
  tabIndex,
  variant,
  size,
  color,
  icon,
  iconSize,
  iconAlignment,
  isActive,
  onClick,
  className,
  style,
  children,
}: ButtonProps & AnchorHTMLAttributes<HTMLAnchorElement>) => {
  return (
    <a
      href={href}
      target={target}
      tabIndex={tabIndex}
      rel={rel}
      onClick={onClick}
      className={cx(
        getButtonStyles({ variant, size, color, isActive }),
        className,
      )}
      style={style}
    >
      {children}
      {icon && (
        <ButtonIcon
          name={icon}
          alignment={iconAlignment}
          className={cx(iconSize ? iconSizeClasses[iconSize] : {})}
        />
      )}
    </a>
  )
}

export default ButtonLink
